import {useNavigate} from "react-router-dom";

const usePaperlessNavigate = () => {
    const navigate = useNavigate();
    const paperlessNavigate = ({destination, payload}) => {
        navigate(destination, {state: payload});
    }
    return {paperlessNavigate}
}
export default usePaperlessNavigate;
